import {OfertaListFilter} from '../models/oferta.model';
import {UserFisicaData, UserJuridicaData} from '../models/user-data.model';
import {UserDocumentTypeListRequest} from '../models/user-document-type-list-request';

export class IncrementLimitFisicaAction {
  static readonly type = '[Limit] IncrementUserFisicaLimitAction';
  constructor(public payload: any) {}
}

export class IncrementLimitJuridicaAction {
  static readonly type = '[Limit] IncrementUserJuridicaLimitAction';
  constructor(public payload: any) {}
}

export class UpdateUserDocumentWithTypeIdAction {
  static readonly type = '[Profile] UpdateUserDocumentWithTypeIdAction';
  constructor(public payload: { userDocumentTypeList: UserDocumentTypeListRequest }) {
  }
}
export class GetUserDocumentAction {
  static readonly type = '[Profile] GetUserDocumentAction';
  constructor() {
  }
}
export class DownloadUserDocumentByIdAction {
  static readonly type = '[Profile] DownloadUserDocumentByIdAction';
  constructor(public payload: {documentId: number}) {
  }
}
